import { render, staticRenderFns } from "./menu-grid-item.vue?vue&type=template&id=ef1a848a&scoped=true&"
import script from "./menu-grid-item.vue?vue&type=script&lang=js&"
export * from "./menu-grid-item.vue?vue&type=script&lang=js&"
import style0 from "./menu-grid-item.vue?vue&type=style&index=0&id=ef1a848a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1a848a",
  null
  
)

export default component.exports